import { useMemo } from "react";
import { useSelector } from "react-redux";
import SecondaryHeader from "../../../DemoState/Demand/SecondaryHeader";
import ExchangeMetricsForm from "./PriceAnalysisForm";
import BankingCalculatorForm from "./BankingCalculatorForm";

const TABS = [
  { label: "Price Metrics", value: "price_metrics" },
  { label: "Banking Calculator", value: "banking" },
];

export function ExchangeMetrics() {
  const activeViewMode = useSelector((state: any) => state.viewMode.activeView);
  const activeTab = activeViewMode?.value || "price_metrics";

  return (
    <div className="flex flex-col gap-2 m-3 justify-between">
      <SecondaryHeader customDataTabs={TABS} />
      {activeTab === "banking" ? <BankingCalculatorForm /> : <ExchangeMetricsForm />}
    </div>
  );
}
